import { render } from "./LoggingView.vue?vue&type=template&id=663b68a6&scoped=true"
import script from "./LoggingView.vue?vue&type=script&lang=js"
export * from "./LoggingView.vue?vue&type=script&lang=js"

import "./LoggingView.vue?vue&type=style&index=0&id=663b68a6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663b68a6"]])

export default __exports__